<template>
	<FlowTreeTriggerSection :triggerType="triggerType" :title="title" v-on="$listeners" />
</template>

<script>
import FlowTreeTriggerSection from './FlowTreeTriggerSection.vue';
import TriggerService from './trigger-service';
import ElementContextMixin from '../BlockEditor/TriggerEditor/ElementContextMixin';
import { NodeTypes } from '@/components/FlowTree/flow-tree-service.const';
import PlacementService from '@/utils/placement-service';
export default {
	name: 'AddOnTriggerSection',
	mixins: [ElementContextMixin],
	components: { FlowTreeTriggerSection },
	computed: {
		itemName() {
			return PlacementService.getFullItemName(this.placement);
		},
		serviceName() {
			return this.service?.service_name;
		},
		addOnType() {
			return PlacementService.getAddOnType(this.placement, this.element.type);
		},
		title() {
			return TriggerService.getTriggerTitle(this.itemName, this.serviceName, this.addOnType);
		},
	},
	data() {
		return { triggerType: NodeTypes.AddOnTrigger };
	},
};
</script>

<style lang="scss" scoped></style>
